// src/actions/favouritesActions.js

import axios from 'axios';
import {
  GET_ALL_FAVOURITES_REQUEST,
  GET_ALL_FAVOURITES_SUCCESS,
  GET_ALL_FAVOURITES_FAIL,
  ADD_FAVOURITE_REQUEST,
  ADD_FAVOURITE_SUCCESS,
  ADD_FAVOURITE_FAIL,
  UPDATE_FAVOURITE_REQUEST,
  UPDATE_FAVOURITE_SUCCESS,
  UPDATE_FAVOURITE_FAIL,
  DELETE_FAVOURITE_REQUEST,
  DELETE_FAVOURITE_SUCCESS,
  DELETE_FAVOURITE_FAIL,
  baseURL
} from './types';

const API_BASE_URL = `${baseURL}/api/appointementDoctorFavourites`;

// --- GET ALL FAVOURITES for a Patient ---
export const getAllFavourites = (patientId) => async (dispatch) => {
  dispatch({ type: GET_ALL_FAVOURITES_REQUEST });
  try {
    const token = localStorage.getItem('token'); // Get token from storage

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`, // Add Authorization header
      },
    };

    const { data } = await axios.post(
      `${API_BASE_URL}/getall`,
      { PatientID: patientId },
      config // Pass the config with headers
    );

    if (data.success) {
      dispatch({
        type: GET_ALL_FAVOURITES_SUCCESS,
        payload: data.data,
      });
    } else {
      throw new Error(data.message || 'Failed to fetch favourites');
    }
  } catch (error) {
    dispatch({
      type: GET_ALL_FAVOURITES_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
// --- ADD a new FAVOURITE ---
export const addFavourite = (favouriteData) => async (dispatch) => {
    dispatch({ type: ADD_FAVOURITE_REQUEST });
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } };
      const { data } = await axios.post(`${API_BASE_URL}/create`, favouriteData, config);
  
      if (data.success && data.data) {
        // --- (THIS IS THE FIX) ---
        // Ensure the payload is always a single object, even if the API returns an array.
        const newFavourite = Array.isArray(data.data) ? data.data[0] : data.data;
  
        dispatch({
          type: ADD_FAVOURITE_SUCCESS,
          payload: newFavourite, // Dispatch the single object
        });
      } else {
        throw new Error(data.message || 'Failed to add favourite');
      }
    } catch (error) {
      dispatch({
        type: ADD_FAVOURITE_FAIL,
        payload: error.response?.data?.message || error.message,
      });
    }
  };
// --- UPDATE a FAVOURITE ---
export const updateFavourite = (updateData) => async (dispatch) => {
    dispatch({ type: UPDATE_FAVOURITE_REQUEST });
    try {
        const token = localStorage.getItem('token'); // Get token from storage

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`, // Add Authorization header
            },
        };

        const { data } = await axios.patch(
            `${API_BASE_URL}/update`,
            updateData,
            config // Pass the config with headers
        );

        if (data.success) {
            dispatch({
                type: UPDATE_FAVOURITE_SUCCESS,
                payload: data.data,
            });
        } else {
            throw new Error(data.message || 'Failed to update favourite');
        }
    } catch (error) {
        dispatch({
            type: UPDATE_FAVOURITE_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};

// --- DELETE a FAVOURITE ---
export const deleteFavourite = (favouriteId) => async (dispatch) => {
  dispatch({ type: DELETE_FAVOURITE_REQUEST });
  try {
    const token = localStorage.getItem('token'); // Get token from storage

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`, // Add Authorization header
      },
      data: { id: favouriteId }, // For DELETE requests, the body is sent in the `data` property
    };

    const { data } = await axios.delete(
        `${API_BASE_URL}/delete`,
        config // Pass the entire config object
    );

    if (data.success) {
      dispatch({
        type: DELETE_FAVOURITE_SUCCESS,
        payload: favouriteId,
      });
    } else {
      throw new Error(data.message || 'Failed to delete favourite');
    }
  } catch (error) {
    dispatch({
      type: DELETE_FAVOURITE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};